// extracted by mini-css-extract-plugin
export default {"fontTitle":"ItemCart_fontTitle__Lle6b","fontSize":"ItemCart_fontSize__vod-y","color":"ItemCart_color__ElLtL","ico":"ItemCart_ico__uWBrh","bold":"ItemCart_bold__okZim"};